import { Reveal, Eyebrow } from "../site/Reveal";
import { BENEFITS } from "../../lib/content";

const Card = ({ b, i, className = "", dark = false, withImage = false, children }) => {
  const Icon = b.icon;
  return (
    <Reveal delay={i * 0.08} className={className}>
      <article data-testid={`benefit-card-${i}`} className={`group relative flex h-full min-h-[300px] flex-col justify-between overflow-hidden rounded-[1.75rem] p-7 sm:p-9 ${dark ? "bg-forest text-white" : "border border-forest/10 bg-white"}`}>
        {children}
        <span className={`relative grid h-14 w-14 place-items-center rounded-2xl transition-transform duration-500 group-hover:rotate-[-8deg] ${dark ? "bg-gold text-forest" : "bg-solar-soft text-solar"}`}>
          <Icon className="h-6 w-6" strokeWidth={1.6} />
        </span>
        <div className={`relative mt-10 ${withImage ? "md:max-w-[48%]" : ""}`}>
          <h3 className={`font-display text-2xl font-medium leading-tight tracking-tight ${dark ? "text-white" : "text-forest"}`}>{b.title}</h3>
          <p className={`mt-3 max-w-md text-[15px] leading-relaxed ${dark ? "text-white/80" : "text-ink/75"}`}>{b.text}</p>
        </div>
      </article>
    </Reveal>
  );
};

export const Benefits = () => (
  <section data-testid="benefits-section" className="bg-paper py-24 sm:py-32">
    <div className="container-x">
      <div className="grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow>Vantagens</Eyebrow>
          <Reveal><h2 className="mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-tight text-forest sm:text-5xl lg:text-6xl">Energia produzida onde é consumida.</h2></Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-5"><p className="text-ink/75 leading-relaxed md:text-lg">Um sistema fotovoltaico bem pensado ajuda a reduzir a dependência da rede elétrica. Os resultados dependem sempre do consumo, do local e da solução escolhida.</p></Reveal>
      </div>
      <div className="mt-14 grid gap-5 lg:grid-cols-6 lg:grid-rows-2">
        <Card b={BENEFITS[0]} i={0} dark withImage className="lg:col-span-4">
          <img src="/images/telhado.jpg" alt="" aria-hidden="true" loading="lazy" className="absolute inset-y-0 right-0 hidden h-full w-1/2 object-cover opacity-90 [clip-path:polygon(18%_0,100%_0,100%_100%,0_100%)] transition-transform duration-[1.2s] group-hover:scale-105 md:block" />
        </Card>
        <Card b={BENEFITS[1]} i={1} className="lg:col-span-2">
          <div aria-hidden="true" className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-gold/25 transition-transform duration-700 group-hover:scale-125" />
        </Card>
        <Card b={BENEFITS[2]} i={2} className="lg:col-span-2">
          <div aria-hidden="true" className="absolute right-6 top-6 grid grid-cols-3 gap-1.5 transition-transform duration-700 group-hover:-translate-y-1">
            {Array.from({ length: 9 }).map((_, k) => <span key={k} className={`h-5 w-5 rounded-[6px] ${k === 2 ? "bg-leaf" : "bg-solar/80"}`} style={{ opacity: 0.25 + (k % 3) * 0.2 }} />)}
          </div>
        </Card>
        <Card b={BENEFITS[3]} i={3} withImage className="lg:col-span-4">
          <img src="/images/detalhe.jpg" alt="" aria-hidden="true" loading="lazy" className="absolute inset-y-0 right-0 hidden h-full w-1/2 object-cover [clip-path:polygon(18%_0,100%_0,100%_100%,0_100%)] transition-transform duration-[1.2s] group-hover:scale-105 md:block" />
        </Card>
      </div>
    </div>
  </section>
);
